if (!customElements.get('instafeed-slider')) {
  class InstafeedSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        slidesPerView: 'auto',
        freeMode: {
          enabled: true,
          sticky: true,
        },
      };

      this.observeDOM();
    }

    observeDOM() {
      const config = { attributes: false, childList: true, subtree: true };

      const callback = (mutationList, observer) => {
        setTimeout(() => {
          if (this.querySelector('.instafeed-new-layout-wrapper')) {
            const container = this.querySelector(
              '.instafeed-new-layout-container',
            );
            const wrapper = this.querySelector('.instafeed-new-layout-wrapper');

            if (container?.classList.contains('swiper')) {
              return;
            }

            container?.classList.add('swiper');
            wrapper?.classList.add('swiper-wrapper');
            wrapper
              .querySelectorAll('.instafeed-new-layout-item')
              .forEach((item) => item.classList.add('swiper-slide'));

            this.slider = new Swiper(container, this.settings);
            observer?.disconnect();
          }
        }, 500);
      };

      const observer = new MutationObserver(callback);
      observer.observe(this, config);

      window.addEventListener('resize', callback);
    }
  }
  customElements.define('instafeed-slider', InstafeedSlider);
}
